// src/pages/PasswordResetRequest.js
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { requestPasswordReset } from '../services/api/UserService';
import '../styles/PasswordReset.css';
import '../styles/button.css';
import ircLogo from '../assets/img/as-finder-logo.svg';
import mailAddressIcon from '../assets/img/mail-address.svg';

const PasswordResetRequest = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false); // 成功メッセージ表示用

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    setSuccess(false);
    
    try {
      // APIエンドポイントにリクエストを送信
      const response = await requestPasswordReset(email);
      
      setSuccess(true);
      setLoading(false);
      setError(''); // エラーをクリア
      
      // 注意: パスワードリセットリクエスト後は、ユーザーがメールを確認する必要があるため
      // 自動的に画面遷移しません。メッセージを表示して、ユーザーに指示します。
    } catch (error) {
      // エラーダイアログ表示はBaseApiServiceで行う
      // エラーコンソール出力は各ApiServiceで行う
    } finally {
      setLoading(false);
    }
  };
  
  const handleBack = () => {
    const userType = localStorage.getItem('userType');

    localStorage.removeItem('token');
    localStorage.removeItem('userInfo');

    if (userType) {
      navigate(`/${userType}/login`);
    } else {
      // ユーザータイプが取得できない場合は、募集人サイトログイン画面に遷移
      navigate('/solicitor/login');
    }
  };

  return (
    <div className="password-reset-container">
      <div className="login-background">
      </div>
      
      <div className="password-reset-card">
        <div className="logo-header">
          <img src={ircLogo} alt="IRC 株式会社アイリックコーポレーション" className="main-logo" />
        </div>
        
        <h2 className="reset-title">パスワード再設定</h2>
        
        {success ? (
          <div className="success-message">
            <p>パスワード再設定の手順をメールで送信しました。</p>
            <p>メールに記載されたリンクからパスワードの再設定を行ってください。</p>
            <div className="button-group button-group--mt-l">
              <button type="button" className="button button-primary button-large" onClick={handleBack}>
                ログイン画面へ戻る
              </button>
            </div>
          </div>
        ) : (
          <>
            <p className="instruction-text">
              パスワードを再設定するには、メールアドレスを入力してください。
            </p>
            
            {error && <div className="error-message">{error}</div>}
            
            <form onSubmit={handleSubmit} className="reset-form">
              <div className="input-group">
                <div className="icon-container">
                  <img src={mailAddressIcon} alt="メールアドレス" className="icon user-icon" />
                </div>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="メールアドレス"
                  required
                />
              </div>
              
              <div className="button-group button-group--mt-l">
                <button type="button" className="button button-secondary button-large" onClick={handleBack}>
                  戻る
                </button>
                <button
                  type="submit"
                  className="button button-primary button-large"
                  disabled={loading}
                >
                  {loading ? '送信中...' : '送信'}
                </button>
              </div>
            </form>
          </>
        )}
      </div>
    </div>
  );
};

export default PasswordResetRequest;